import React from "react";
import { Container } from "@mui/material";
import BottomMenu from "pages/HomePage/component/BottomMenu";
import { useMediaQueryState } from '../../hooks/useMediaQueryState';
import TopMenu from './TopMenu';

interface HeaderContentProps {}

function HeaderContent(props: React.PropsWithChildren<HeaderContentProps>) {
  const { children } = props;
  const {isMobile, isPC} = useMediaQueryState();

  return (
    <>
      {!isMobile && <TopMenu />}
      <Container sx={{ position: isPC ? 'relative' : 'inherit', paddingLeft: 0, paddingRight: 0 }}>{children}</Container>
      {isMobile && <BottomMenu />}
    </>
  );
}
export default HeaderContent;
